/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_TitleInputs */

const en_admin_statistics_title = /** @type {(inputs: Admin_Statistics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistics`)
};

const de_admin_statistics_title = /** @type {(inputs: Admin_Statistics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiken`)
};

/**
* | output |
* | --- |
* | "Statistics" |
*
* @param {Admin_Statistics_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_title = /** @type {((inputs?: Admin_Statistics_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_title(inputs)
	return en_admin_statistics_title(inputs)
});